// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"0a462127","426":"5e5abc94","453":"9a389856"}[chunkId] + ".chunk.js";
};